import CategoryService from '@/services/category.service.js'

const state = {
  categories: [],
  loading: false
}

const getters = {
  categories: state => state.categories,
  loading: state => state.loading
}

const actions = {
  async fetchCategories({ commit, dispatch }, params = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await CategoryService.getCategories(params)
      const data = response.payload?.responseData || response.payload || response
      commit('SET_CATEGORIES', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load categories',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createCategory({ commit, dispatch }, payload) {
    try {
      commit('SET_LOADING', true)
      const response = await CategoryService.createCategory(payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Category created successfully',
        { root: true }
      )
      await dispatch('fetchCategories')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to create category',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateCategory({ commit, dispatch }, { id, payload }) {
    try {
      commit('SET_LOADING', true)
      const response = await CategoryService.updateCategory(id, payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Category updated successfully',
        { root: true }
      )
      await dispatch('fetchCategories')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to update category',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteCategory({ commit, dispatch }, id) {
    try {
      commit('SET_LOADING', true)
      const response = await CategoryService.deleteCategory(id)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Category deleted successfully',
        { root: true }
      )
      await dispatch('fetchCategories')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to delete category',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const mutations = {
  SET_CATEGORIES(state, data) {
    state.categories = Array.isArray(data) ? data : (data.categories || [])
  },
  SET_LOADING(state, value) {
    state.loading = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
